import React from "react";
import PropTypes from "prop-types";
import Section from "../common/Section";
import Row from "../common/Row";
import ValidationStatusList from "./ValidationStatusList";
import Form from "../common/Form";
import Fieldset from "../common/Fieldset";
import Button from "../common/Button";
import moment from "moment";
import DownloadUploadFile from "../common/DownloadUploadFiles";
import * as DomainConstants from "../../constants/DomainConstants";

const IndienenForm = ({ indienen, disabled, onDienIn, color, pdf, isPollingDocument, generatePdf, ondertekendePdfFiles, onDropOndertekendePdf, onDeleteOndertekendePdf, fileTypes, fileSessionStarted, disableOndertekendePdfUpload }) => {
    let itemsFrontendList = [];

    let wijktTotaleFinancieringAfVanTotaleInvestering = false;
    if (indienen.wijktTotaleFinancieringAfVanTotaleInvestering != null) {
        wijktTotaleFinancieringAfVanTotaleInvestering = indienen.wijktTotaleFinancieringAfVanTotaleInvestering;
    }

    let isTotaalKostenOpbrengstenNegatief = false;
    if (indienen.isTotaalKostenOpbrengstenNegatief != null) {
        isTotaalKostenOpbrengstenNegatief = indienen.isTotaalKostenOpbrengstenNegatief;
    }

    let isTotaalBedrijfskostenOfOpbrengstenNull = false;
    if (indienen.isTotaalBedrijfskostenOfOpbrengstenNull != null) {
        isTotaalBedrijfskostenOfOpbrengstenNull = indienen.isTotaalBedrijfskostenOfOpbrengstenNull;
    }

    let isMinimaalSportgerelateerdeInvesteringNietGehaald = false;
    if (indienen.isMinimaalSportgerelateerdeInvesteringNietGehaald != null) {
        isMinimaalSportgerelateerdeInvesteringNietGehaald = indienen.isMinimaalSportgerelateerdeInvesteringNietGehaald;
    }

    if (wijktTotaleFinancieringAfVanTotaleInvestering) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen gezien er geen 100% financiering van het project werd aangetoond rekening houdend met een eventuele minimale subsidie.',
                url: '/financieel/' + indienen.dossierId + "/financiering"
            }
        );
    }

    if (isTotaalKostenOpbrengstenNegatief) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen met een negatief verschil tussen de opbrengsten en kosten over een periode van 10 jaar van het project bij het criterium “financiële duurzaamheid”.',
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (isTotaalBedrijfskostenOfOpbrengstenNull) {
        itemsFrontendList.push(
            {
                text: 'Je kan niet indienen zonder een inschatting te maken van bedrijfsopbrengsten en bedrijfskosten.',
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (isMinimaalSportgerelateerdeInvesteringNietGehaald) {
        itemsFrontendList.push(
            {
                text: `Je kan niet indienen als het totaal van de sportgerelateerde investeringen (Excl BTW) van je project minder is dan €${indienen.minSportgerelateerdeInvesteringenExclBtw.toLocaleString(
                    undefined,
                    { minimumFractionDigits: 0 }
                )}.`,
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    if (indienen.infrastructurenZonderInvestering && indienen.infrastructurenZonderInvestering.length) {
        itemsFrontendList.push(
            {
                text: 'Er zijn geen investeringen opgegeven voor infrastructuur ' + indienen.infrastructurenZonderInvestering.join(', '),
                url: '/financieel/' + indienen.dossierId
            }
        );
    }

    const heeftWarnings = disabled || indienen.nrOfWarnings > 0 || wijktTotaleFinancieringAfVanTotaleInvestering || itemsFrontendList.length > 0;
    const heeftOndertekendePdf = ondertekendePdfFiles && ondertekendePdfFiles.length > 0;
    const indienenIsDisabled = heeftWarnings || indienen.isIndiendatumVerstreken || wijktTotaleFinancieringAfVanTotaleInvestering || !heeftOndertekendePdf;
    const uitersteDatumIndienen = indienen.uitersteDatumIndienen ? moment(indienen.uitersteDatumIndienen).format("DD-MM-YYYY") : null;
    const uitersteDatumIndienenPlus1Month = indienen.uitersteDatumIndienen ? moment(indienen.uitersteDatumIndienen).add(1, "months").format("DD-MM-YYYY") : null;

    return (<Section title="Dien in" color={color}>
        <Form
            title="Bevestigingsformulier"
            name="indienen"
            isNotRequired>
            <Fieldset>

                {uitersteDatumIndienen && !indienen.isIndiendatumVerstreken ? (
                    <>
                        <b>Je kan dossiers indienen tot en met {uitersteDatumIndienen}</b>
                        <br />
                    </>
                ) : null}
                <br />
                {heeftWarnings || itemsFrontendList.length > 0 ? <p style={{ color: 'red' }}>Het dossier is nog niet klaar om ingediend te worden.</p> : ""}
                <br />
                {heeftWarnings || itemsFrontendList.length > 0 ? <ValidationStatusList items={indienen.validatieStatussen} itemsFrontend={itemsFrontendList} dossierType={indienen.typeDossier} /> : ""}
            </Fieldset>
            {!(heeftWarnings || itemsFrontendList.length > 0) ? (
                <>
                    <Fieldset>
                        <p>Om de aanvraag in te dienen moeten volgende stappen doorlopen worden:</p>
                        <ul style={{ listStyle: 'none' }}>
                            <li>* Controleer goed of alle vragen beantwoord zijn en alle nodige documenten opgeladen zijn.</li>
                            <li>* Wanneer je je dossier hebt ingediend, kan je geen wijzigingen meer aanbrengen!</li>
                            <li>* Klik op 'genereer pdf' en download hieronder links een pdf-versie van de subsidieaanvraag.</li>
                            <li>* Laat de pdf-versie ondertekenen door de gemandateerde(n) van de subsidieaanvrager(s).</li>
                            <li>* Upload hieronder rechts een ondertekende pdf-versie.</li>
                            <li>* Klik op 'dien in' om de subsidieaanvraag definitief in te dienen.</li>
                            <li>* De 2 contactpersonen van het dossier ontvangen een e-mail ter bevestiging van de indiening van je subsidieaanvraag</li>
                        </ul>
                    </Fieldset>
                    <Fieldset>
                        <Row>
                            <DownloadUploadFile
                                dossierId={indienen.dossierId}
                                title="PDF van de subsidieaanvraag"
                                size={6}
                                tab=""
                                component=""
                                files={pdf.files || []}
                                color={color}
                                downloadOnly
                                isPdf />

                            <DownloadUploadFile
                                dossierId={indienen.dossierId}
                                title="Ondertekende PDF subsidieaanvraag"
                                size={6}
                                tab={DomainConstants.DocumentTab.Indienen}
                                component={DomainConstants.ComponentName.OndertekendePDF}
                                files={ondertekendePdfFiles}
                                color={color}
                                onDrop={!disableOndertekendePdfUpload ? onDropOndertekendePdf : null}
                                onDelete={onDeleteOndertekendePdf}
                                fileTypes={fileTypes}
                                fileSessionStarted={fileSessionStarted}
                                disabled={disabled}
                                tooltip="Upload hier de ondertekende PDF. Er kan maar 1 document geüpload worden."
                                isOndertekendePdfSubsidie />
                        </Row>
                    </Fieldset>
                    <Fieldset>
                        <Row>
                            <div className="o-col-12" style={{ textAlign: 'right' }}>
                                <Button
                                    text="Genereer PDF"
                                    onClick={generatePdf}
                                    disabled={isPollingDocument || disabled} />
                                {' '}
                                <Button
                                    text="Dien in"
                                    onClick={onDienIn}
                                    disabled={indienenIsDisabled} />
                            </div>
                        </Row>
                    </Fieldset>
                </>
            ) : null}
        </Form>
    </Section>);
};

IndienenForm.propTypes = {
    indienen: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onDienIn: PropTypes.func,
    color: PropTypes.string,
    pdf: PropTypes.object,
    isPollingDocument: PropTypes.bool,
    generatePdf: PropTypes.func,
    ondertekendePdfFiles: PropTypes.array,
    onDropOndertekendePdf: PropTypes.func,
    onDeleteOndertekendePdf: PropTypes.func,
    fileTypes: PropTypes.object,
    fileSessionStarted: PropTypes.bool,
    disableOndertekendePdfUpload: PropTypes.bool
};

export default IndienenForm;
